import { inject } from '@angular/core';
import { ResolveFn } from '@angular/router';
import { AuthService } from '../services/auth.service';

export const identityResolver: ResolveFn<Promise<boolean>> = async (route, state) => {
  const service = inject(AuthService);
  if(!service.hasToken()){ return Promise.resolve(true) }
  return await service.getMyself();
};
